import React, { useEffect, useRef } from 'react';
import './style.scss';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import icons from '../../../../../../common/Icons';

import { v1 as uuid } from 'uuid';

const CardsListCardRewardsContent = ({
  topHeading,
  bottomHeading,
  iconsList,
  description,
  opened,
  oneCard = false,
  onHeightChange,
  contentItemRef,
}) => {
  const needTopHeading = !!topHeading?.value;
  const needBottomHeading = !!bottomHeading?.value;
  const needDescription = !!description?.value;
  const needIconsList = iconsList?.length > 0;

  const ref = useRef(null);

  useEffect(() => {
    if (oneCard && onHeightChange) {
      if (!opened) {
        onHeightChange(0);
      } else {
        const height = ref?.current?.scrollHeight;
        onHeightChange(height);
      }
    }
  }, [opened]);

  return (
    <div
      className={clsx(
        'cards-list-card-rewards-content',
        opened && 'clcrc-opened',
        oneCard && 'one-card'
      )}
      ref={ref}
    >
      <div className="content" ref={contentItemRef}>
        <div className="innerContent">
          {(needTopHeading || needDescription) && (
            <>
              {needTopHeading && (
                <div className="clcr-content-heading">
                  <div className="clcr-content-heading-icon">
                    <img alt='' src={icons.percentage} />
                  </div>
                  <Text field={topHeading} />
                </div>
              )}
              {needDescription && (
                <RichText field={description} className="clcr-content-description" />
              )}
            </>
          )}
          {(needBottomHeading || needIconsList) && (
            <div className="clcr-content-icons-wrapper">
              {needBottomHeading && (
                <div className="clcr-content-heading">
                  <Text field={bottomHeading} />
                </div>
              )}
              {needIconsList && (
                <div className="clcr-content-icons">
                  {iconsList.map((icon) => (
                    <Image field={icon.fields.image} className="clcr-content-icon" key={uuid()} />
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardsListCardRewardsContent;
